var map = {
	"./age.svg": "04ae",
	"./all-employees.svg": "de38",
	"./calendar.svg": "b8bd",
	"./comment.svg": "c47d",
	"./employees.svg": "578a",
	"./new-employee.svg": "3123",
	"./new-report.svg": "74ab",
	"./reports.svg": "aa1a",
	"./role.svg": "b198",
	"./sprints.svg": "c03e",
	"./tasks.svg": "e882",
	"./todo.svg": "4694"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";